<template>
  <nav
    class="navbar navbar-vertical fixed-left navbar-expand-md navbar-light bg-white"
    id="sidenav-main"
    :class="{ active: active }"
  >
    <div class="container-fluid d-none d-md-flex">
      <!-- Toggler -->
      <navbar-toggle-button @click.native="showSidebar">
        <span class="navbar-toggler-icon"></span>
      </navbar-toggle-button>
      <router-link class="navbar-brand" to="/">
        <img
          :src="require('@/assets/img/brand/' + clientType + '/brand-icon.svg')"
          class="navbar-brand-img brand-icon"
          width="42"
          alt="..."
        />
        <span class="nav-link-text nav-logo-text">
          <img
            :src="require('@/assets/img/brand/mailercloud/text-logo.svg')"
            alt="..."
          />
        </span>
      </router-link>

      <slot></slot>
      <div
        v-show="$sidebar.showSidebar"
        class="navbar-collapse collapse show"
        id="sidenav-collapse-main"
      >
        <ul
          class="navbar-nav nav-menubar"
          :class="{
            'menu-h-1': allowTransaction || parseInt(isWelcomeDashboard) !== 2,
            'menu-h-2': allowTransaction && isWelcomeDashboard !== 2,
          }"
        >
          <slot name="links"> </slot>
        </ul>
      </div>

      <ul class="navbar-nav flex-end">
        <li
          v-if="
            parseInt(loginData.plan) !== 3 && parseInt(isWelcomeDashboard) === 2
          "
          class="nav-item upgrade-navitem overflow-hidden"
        >
          <div class="upgrade-navitem-inner">
            <b-link class="nav-link" to="/change-plan">
              <span class="ico-sidebar upgrade-holder"
                ><img
                  src="@/assets/img/icons/dashboard/upgrade-icon.svg"
                  alt="upgrade"
                  width="24"
                />
                <img
                  src="@/assets/img/icons/dashboard/upgrade-icon.svg"
                  class="upgrade-hover-icon"
                  width="24"
                />
              </span>
              <span class="nav-link-text">Upgrade Plan</span>
            </b-link>
          </div>
        </li>
        <li
          v-show="parseInt(isWelcomeDashboard) !== 2"
          class="nav-noti-li hover-img"
        >
          <a
            href="javascript:void(0)"
            class="nav-link d-flex align-self-center nav-noti"
            id="popoverMenuNoti"
          >
            <div class="nav-noti">
              <div class="pie-wrapper" :class="'progress-' + getProgress">
                <span class="label">
                  <span class="vh-center position-absolute">
                    <img
                      src="@/assets/img/icons/dashboard/animated-black-arrow.svg"
                      alt=""
                      width="18"
                      class="hover-none"
                    />
                    <img
                      src="@/assets/img/icons/dashboard/blue-right-arrow.svg"
                      alt=""
                      width="18"
                      class="hover-visible"
                    />
                  </span>
                </span>
                <div class="pie">
                  <div class="left-side half-circle"></div>
                  <div class="right-side half-circle"></div>
                </div>
                <div class="shadow"></div>
              </div>
            </div>
            <div class="nav-link-text">
              <p class="mb-0 mt-0 font-13 font-weight-bold">Basic setup</p>
              <p class="mb-0 font-12">Set {{ stageCompleted }} of 4</p>
            </div>
            <div class="dark-tooltip pop-menu-noti">
              <div id="popNoti"></div>
            </div>
          </a>
          <b-popover
            target="popoverMenuNoti"
            triggers="hover"
            placement="topleft"
            container="popNoti"
            :show.sync="showPopNoti"
            no-fade
          >
            <span class="pop-close d-none" @click="showPopNoti = !showPopNoti"
              ><img src="@/assets/img/builder/close-white-sm.svg" width="9"
            /></span>
            <p class="font-13 font-weight-bold mb-2">
              You are just {{ getPending }}
              {{ getPending > 1 ? "steps" : "step" }} away!
            </p>
            <b-progress height="6px" :max="100" class="mb-3 radius-4">
              <b-progress-bar
                :value="getProgress"
                variant="primary"
              ></b-progress-bar>
            </b-progress>
            <ul class="list-unstyled menu-step-ul">
              <li
                @click="goTo('contact')"
                :class="{
                  completed: welcomeDashboardItems.addContact === 2,
                  current: getCurrentClass === 'addContact',
                }"
              >
                <span
                  class="state-ico"
                  :class="welcomeDashboardItems.addContact !== 2 ? 'order' : ''"
                >
                  <img
                    v-if="welcomeDashboardItems.addContact === 2"
                    src="@/assets/img/icons/tick-success-fill.svg"
                    class="success-img"
                    width="24"
                  />
                  {{ welcomeDashboardItems.addContact === 2 ? "" : 1 }}
                </span>
                {{
                  welcomeDashboardItems.addContact === 2
                    ? "Audience added"
                    : "Add your audience"
                }}
                <span class="arrow-link">
                  <img
                    src="@/assets/img/icons/dashboard/arrow-circle-right-primary.svg"
                    width="18"
                  />
                </span>
              </li>
              <li
                @click="goTo('domain')"
                :class="{
                  completed: welcomeDashboardItems.addDomain === 2,
                  current: getCurrentClass === 'addDomain',
                  loading: welcomeDashboardItems.addDomain === 1,
                }"
              >
                <span class="state-ico order">
                  <span
                    v-if="welcomeDashboardItems.addDomain === 1"
                    class="d-flex vh-center position-absolute"
                  >
                    <!--<b-spinner variant="primary" label="Spinning"></b-spinner>-->
                    <img
                      src="@/assets/img/icons/dashboard/info-yellow-animated.svg"
                      width="24"
                    />
                  </span>
                  <img
                    v-if="welcomeDashboardItems.addDomain === 2"
                    src="@/assets/img/icons/tick-success-fill.svg"
                    class="success-img"
                    width="24"
                  />
                  {{ welcomeDashboardItems.addDomain === 2 ? "" : 2 }}
                </span>
                {{
                  welcomeDashboardItems.addDomain === 2
                    ? "Domain authenticated"
                    : welcomeDashboardItems.addDomain === 1
                    ? "Checking domain status"
                    : "Authenticate domain"
                }}
                <span class="arrow-link">
                  <img
                    src="@/assets/img/icons/dashboard/arrow-circle-right-primary.svg"
                    width="18"
                  />
                </span>
              </li>
              <li
                @click="goTo('senderId')"
                :title="
                  getStepDisableClass('senderId') === true
                    ? 'Please complete the previous steps'
                    : ''
                "
                :class="{
                  'step-disabled': getStepDisableClass('senderId') === true,
                  completed: welcomeDashboardItems.addSenderId === 2,
                  current: getCurrentClass === 'addSenderId',
                }"
              >
                <span
                  class="state-ico"
                  :class="{ order: welcomeDashboardItems.addSenderId === 0 }"
                >
                  <img
                    v-if="welcomeDashboardItems.addSenderId === 2"
                    src="@/assets/img/icons/tick-success-fill.svg"
                    class="success-img"
                    width="24"
                  />
                  <img
                    v-if="welcomeDashboardItems.addSenderId === 1"
                    src="@/assets/img/icons/dashboard/info-yellow-animated.svg"
                    width="24"
                  />

                  {{ welcomeDashboardItems.addSenderId === 0 ? 3 : "" }}
                </span>
                {{
                  welcomeDashboardItems.addSenderId === 2
                    ? "Sender ID verified"
                    : welcomeDashboardItems.addSenderId === 1
                    ? "Verify your sender ID "
                    : "Create your sender ID"
                }}
                <span class="arrow-link">
                  <img
                    src="@/assets/img/icons/dashboard/arrow-circle-right-primary.svg"
                    width="18"
                  />
                </span>
              </li>
              <li
                @click="goTo('campaign')"
                :title="
                  getStepDisableClass('campaign') === true
                    ? 'Please complete the previous steps'
                    : ''
                "
                :class="{
                  'step-disabled': getStepDisableClass('campaign') === true,
                  completed: welcomeDashboardItems.addCampaign === 2,
                  current: getCurrentClass === 'addCampaign',
                }"
              >
                <span class="state-ico order">
                  <img
                    v-if="welcomeDashboardItems.addCampaign === 2"
                    src="@/assets/img/icons/tick-success-fill.svg"
                    class="success-img"
                    width="24"
                  />
                  {{ welcomeDashboardItems.addCampaign === 2 ? "" : 4 }}
                </span>
                {{
                  welcomeDashboardItems.addCampaign === 0
                    ? "Create your first campaign"
                    : welcomeDashboardItems.addCampaign === 1
                    ? "Publish your campaign now"
                    : "The first campaign created"
                }}

                <span class="arrow-link">
                  <img
                    src="@/assets/img/icons/dashboard/arrow-circle-right-primary.svg"
                    width="18"
                  />
                </span>
              </li>
            </ul>
          </b-popover>
        </li>
        <!----- Transtional--------->
        <li
          class="nav-item te-navitem overflow-hidden"
          v-if="permission < 3 && allowTransaction"
        >
          <div class="te-navitem-inner">
            <b-link class="nav-link" :to="{ path: '/transactional/dashboard' }">
              <span
                class="ico-sidebar transational-holder rounded-circle bg-grey-60"
                ><img
                  src="@/assets/img/icons/menu/transational.svg"
                  class="platform-icon"
                  width="24"
                />
                <img
                  src="@/assets/img/icons/menu/transational-hover.svg"
                  class="platform-hover-icon"
                  width="24"
                />
              </span>
              <span class="nav-link-text">
                <p class="m-0 text-sub-head text-22">API Platform</p>
              </span>
            </b-link>
          </div>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link drop-ico"
            id="popover-profile"
            :class="{ active: active || $route.path.indexOf('/account') != -1 }"
          >
            <span
              v-if="$ls.get('showProfilePic') == 'true'"
              class="ico-sidebar profile-holder rounded-circle"
              :style="{
                'background-image': userData.imageUrl
                  ? userData.imageUrl
                  : $ls.get('profilePicUrl'),
              }"
            >
            </span>

            <span
              v-if="$ls.get('showProfilePic') == 'false'"
              class="round-32 letteravatarbg"
              >{{
                userData.name
                  ? getFirstLetter(userData.name)
                  : getFirstLetter($ls.get("clientName"))
              }}</span
            >

            <span class="nav-link-text">
              <p class="m-0 text-sub-head text-truncate wid-8-em text-22">
                {{
                  userData.name
                    ? userData.name + " " + userData.last_name
                    : $ls.get("clientName")
                }}
              </p>
              <!--<p class="m-0 font-13 text-57 text-truncate wid-11-em">-->
              <!--  {{ $ls.get("username") }}-->
              <!--</p>-->
            </span>
          </b-link>
        </li>
      </ul>
      <b-popover
        v-if="permission < 3 && allowTransaction"
        target="tEmail"
        triggers="click blur"
        placement="righttop"
        ref="refEmail"
        @show="onPopoverShow2"
        no-fade
      >
        <h2 class="font-15 fw-bold mb-4">Mailercloud platforms</h2>
        <ul>
          <li>
            <b-link to="">
              <div class="platform-sub-menu active">
                <img
                  src="@/assets/img/icons/menu/email-marketing.svg"
                  width="24"
                  class="align-middle"
                  alt="email-marketing"
                />
                <span>Email marketing</span>
              </div>
            </b-link>
          </li>
          <li>
            <b-link :to="{ path: '/transactional/dashboard' }">
              <div class="platform-sub-menu">
                <img
                  src="@/assets/img/icons/menu/transational.svg"
                  width="24"
                  class="align-middle"
                  alt="email-marketing"
                />
                <span>Transactional email</span>
              </div>
            </b-link>
          </li>
        </ul>
      </b-popover>
      <!-- <div class="sidebar-bottom-profile">
        <div v-if="$ls.get('showProfilePic')=='true'"><span class="profile-holder rounded-circle" :style="{'background-image': userData.imageUrl?userData.imageUrl:$ls.get('profilePicUrl')}"></span></div>
        <div v-if="$ls.get('showProfilePic')=='false'"><span class="round-40">{{userData.name?getFirstLetter(userData.name):getFirstLetter($ls.get('clientName'))}}</span></div>
      </div> -->
    </div>

    <div class="d-md-none w-100">
      <div>
        <b-row>
          <b-col class="text-center">
            <div class="menu-toggle-ico" @click="mobileMenu = true">
              <img src="@/assets/img/icons/menu-toggle-ico.svg" width="20" />
            </div>
            <b-link to="/">
              <img
                :src="
                  require('@/assets/img/brand/' +
                    clientType +
                    '/brand-logo.svg')
                "
                class="navbar-brand-img"
                height="26"
                alt="Mailercloud"
              />
            </b-link>

            <div v-if="mobileMenu" class="mobile-menu-container">
              <b-link to="/">
                <img
                  :src="
                    require('@/assets/img/brand/' +
                      clientType +
                      '/brand-logo.svg')
                  "
                  class="navbar-brand-img mb-5"
                  height="26"
                  alt="Mailercloud"
                />
              </b-link>
              <div class="menu-mobile-close" @click="mobileMenu = false">
                <img src="@/assets/img/icons/menu-close.svg" width="24" />
              </div>
              <div class="d-flex align-items-start flex-column mob-menu-height">
                <mob-menu @selected="mobileMenu = false" />

                <ul class="navbar-nav mt-auto text-left">
                  <li class="nav-item">
                    <b-link
                      class="nav-link drop-ico"
                      :class="{
                        active: active || $route.path.indexOf('/account') != -1,
                      }"
                      @click="userCardShow = true"
                    >
                      <span
                        v-if="$ls.get('showProfilePic') == 'true'"
                        class="ico-sidebar profile-holder rounded-circle"
                        :style="{
                          'background-image': userData.imageUrl
                            ? userData.imageUrl
                            : $ls.get('profilePicUrl'),
                        }"
                      >
                      </span>

                      <span
                        v-if="$ls.get('showProfilePic') == 'false'"
                        class="round-32 letteravatarbg"
                        >{{
                          userData.name
                            ? getFirstLetter(userData.name)
                            : getFirstLetter($ls.get("clientName"))
                        }}</span
                      >

                      <span class="nav-link-text">
                        <p
                          class="m-0 text-sub-head text-truncate wid-8-em font-weight-bold text-22"
                        >
                          {{
                            userData.name
                              ? userData.name + " " + userData.last_name
                              : $ls.get("clientName")
                          }}
                        </p>
                      </span>
                    </b-link>
                  </li>
                </ul>

                <div v-if="userCardShow" class="user-card-menu-container">
                  <div class="user-card-menu">
                    <div class="user-card-close" @click="userCardShow = false">
                      <img src="@/assets/img/icons/menu-close.svg" width="24" />
                    </div>

                    <ul class="nav-user-drop">
                      <b-dropdown-item disabled>
                        <div class="py-3">
                          <b-media no-body>
                            <b-media-aside
                              vertical-align="center"
                              v-if="$ls.get('showProfilePic') == 'true'"
                            >
                              <div class="position-relative line-h-0">
                                <span
                                  class="profile-holder rounded-circle"
                                  :style="{
                                    'background-image': userData.imageUrl
                                      ? userData.imageUrl
                                      : $ls.get('profilePicUrl'),
                                  }"
                                ></span>
                              </div>
                            </b-media-aside>
                            <b-media-aside
                              vertical-align="center"
                              v-if="$ls.get('showProfilePic') == 'false'"
                            >
                              <span class="round-32 letteravatarbg">{{
                                userData.name
                                  ? getFirstLetter(userData.name)
                                  : getFirstLetter($ls.get("clientName"))
                              }}</span>
                            </b-media-aside>
                            <b-media-body
                              class="align-self-center min-100 ml-3"
                            >
                              <b-row>
                                <b-col
                                  cols="6"
                                  class="font-15 text-sub-head mb-0 font-weight-bold text-truncate"
                                >
                                  {{
                                    userData.name
                                      ? userData.name + " " + userData.last_name
                                      : $ls.get("clientName")
                                  }}
                                </b-col>
                                <b-col cols="auto">
                                  <b-link
                                    class="font-13 account-role"
                                    :to="{ name: 'AccountProfile' }"
                                    >{{ $ls.get("client_role") }}</b-link
                                  >
                                </b-col>
                              </b-row>
                              <b-row>
                                <b-col
                                  class="font-13 text-sub-head-57 text-truncate"
                                  cols="12"
                                >
                                  {{ $ls.get("username") }}
                                </b-col>
                              </b-row>
                            </b-media-body>
                          </b-media>
                        </div>
                      </b-dropdown-item>
                      <b-dropdown-divider
                        class="mt-2 profile-border-none"
                      ></b-dropdown-divider>
                      <b-dropdown-item to="/account/profile"
                        ><div class="d-flex">
                          <span class="nav-drop-ico"
                            ><img
                              src="@/assets/img/icons/drop-ico-profile.svg"
                              width="18"
                              class="align-middle"
                              alt="billing" /></span
                          ><span>Profile</span>
                        </div></b-dropdown-item
                      >
                      <b-dropdown-item
                        :to="{ name: 'StripeInvoices' }"
                        v-if="permission < 3 && !loginData.isLiftime"
                        ><div class="d-flex">
                          <span class="nav-drop-ico"
                            ><img
                              src="@/assets/img/icons/drop-ico-billing.svg"
                              width="18"
                              class="align-middle"
                              alt="billing" /></span
                          ><span>Billing</span>
                        </div></b-dropdown-item
                      >
                      <b-dropdown-item v-if="permission < 3" to="/account"
                        ><div class="d-flex">
                          <span class="nav-drop-ico"
                            ><img
                              src="@/assets/img/icons/drop-ico-settings.svg"
                              width="18"
                              class="align-middle"
                              alt="settings" /></span
                          ><span>Account</span>
                        </div></b-dropdown-item
                      >
                      <b-dropdown-item
                        v-if="permission < 2"
                        to="/logs/contact/import"
                        ><div class="d-flex">
                          <span class="nav-drop-ico"
                            ><img
                              src="@/assets/img/icons/drop-ico-log.svg"
                              width="18"
                              class="align-middle"
                              alt="log" /></span
                          ><span>Logs</span>
                        </div></b-dropdown-item
                      >
                      <!--<b-dropdown-item>-->
                      <!--  <div class="d-flex">-->
                      <!--    <span class="nav-drop-ico"-->
                      <!--      ><img-->
                      <!--        src="@/assets/img/icons/faq.svg"-->
                      <!--        width="18"-->
                      <!--        class="align-middle"-->
                      <!--        alt="faq"-->
                      <!--    /></span>-->
                      <!--    <span>FAQ</span>-->
                      <!--  </div>-->
                      <!--</b-dropdown-item>-->
                      <b-dropdown-item
                        href="https://help.mailercloud.com"
                        target="_blank"
                        @click="mobileMenu = false"
                      >
                        <div class="d-flex">
                          <span class="nav-drop-ico"
                            ><img
                              src="@/assets/img/icons/help.svg"
                              width="18"
                              class="align-middle"
                              alt="help"
                          /></span>
                          <span>Help Center</span>
                        </div>
                      </b-dropdown-item>
                      <b-dropdown-divider class="my-2"></b-dropdown-divider>
                      <b-dropdown-item @click="logout()">
                        <div class="d-flex">
                          <span class="nav-drop-ico"
                            ><img
                              src="@/assets/img/icons/log-out.svg"
                              width="18"
                              class="align-middle"
                              alt="Log out"
                          /></span>
                          <span>Sign Out</span>
                        </div></b-dropdown-item
                      >
                      <b-dropdown-divider class="mt-2"></b-dropdown-divider>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <b-popover
      target="popover-profile"
      triggers="click blur"
      placement="righttop"
      ref="ReffpopoverProfile"
      @show="onPopoverShow"
      @hide="active = false"
    >
      <ul class="nav-user-drop">
        <b-dropdown-item disabled>
          <div class="py-3">
            <b-media no-body>
              <b-media-aside
                vertical-align="center"
                v-if="$ls.get('showProfilePic') == 'true'"
              >
                <div class="position-relative line-h-0">
                  <span
                    class="profile-holder rounded-circle"
                    :style="{
                      'background-image': userData.imageUrl
                        ? userData.imageUrl
                        : $ls.get('profilePicUrl'),
                    }"
                  ></span>
                </div>
              </b-media-aside>
              <b-media-aside
                vertical-align="center"
                v-if="$ls.get('showProfilePic') == 'false'"
              >
                <span class="round-32 letteravatarbg">{{
                  userData.name
                    ? getFirstLetter(userData.name)
                    : getFirstLetter($ls.get("clientName"))
                }}</span>
              </b-media-aside>
              <b-media-body class="align-self-center min-100 ml-3">
                <b-row>
                  <b-col
                    class="font-15 text-sub-head font-weight-bold text-truncate"
                  >
                    {{
                      userData.name
                        ? userData.name + " " + userData.last_name
                        : $ls.get("clientName")
                    }}
                  </b-col>
                  <b-col cols="auto" class="ml-auto">
                    <b-link
                      class="font-13 account-role"
                      :to="{ name: 'AccountProfile' }"
                      >{{ $ls.get("client_role") }}</b-link
                    >
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" class="font-13 text-57 text-truncate">
                    {{ $ls.get("username") }}
                  </b-col>
                </b-row>
              </b-media-body>
            </b-media>
          </div>
        </b-dropdown-item>
        <b-dropdown-divider
          class="mt-2 profile-border-none"
        ></b-dropdown-divider>
        <b-dropdown-item to="/account/profile"
          ><div class="d-flex">
            <span class="nav-drop-ico"
              ><img
                src="@/assets/img/icons/drop-ico-profile.svg"
                width="18"
                class="align-middle"
                alt="billing" /></span
            ><span>Profile</span>
          </div></b-dropdown-item
        >
        <b-dropdown-item
          :to="{ name: 'StripeInvoices' }"
          v-if="permission < 3 && !loginData.isLiftime"
          ><div class="d-flex">
            <span class="nav-drop-ico"
              ><img
                src="@/assets/img/icons/drop-ico-billing.svg"
                width="18"
                class="align-middle"
                alt="billing" /></span
            ><span>Billing</span>
          </div></b-dropdown-item
        >
        <b-dropdown-item v-if="permission < 3" to="/account"
          ><div class="d-flex">
            <span class="nav-drop-ico"
              ><img
                src="@/assets/img/icons/drop-ico-settings.svg"
                width="18"
                class="align-middle"
                alt="settings" /></span
            ><span>Account</span>
          </div></b-dropdown-item
        >
        <b-dropdown-item v-if="permission < 2" to="/logs/contact/import"
          ><div class="d-flex">
            <span class="nav-drop-ico"
              ><img
                src="@/assets/img/icons/drop-ico-log.svg"
                width="18"
                class="align-middle"
                alt="log" /></span
            ><span>Logs</span>
          </div></b-dropdown-item
        >
        <!--<b-dropdown-item>-->
        <!--  <div class="d-flex">-->
        <!--    <span class="nav-drop-ico"-->
        <!--      ><img-->
        <!--        src="@/assets/img/icons/faq.svg"-->
        <!--        width="18"-->
        <!--        class="align-middle"-->
        <!--        alt="faq"-->
        <!--    /></span>-->
        <!--    <span>FAQ</span>-->
        <!--  </div>-->
        <!--</b-dropdown-item>-->
        <b-dropdown-item href="https://help.mailercloud.com" target="_blank">
          <div class="d-flex">
            <span class="nav-drop-ico"
              ><img
                src="@/assets/img/icons/help.svg"
                width="18"
                class="align-middle"
                alt="help"
            /></span>
            <span>Help Center</span>
          </div>
        </b-dropdown-item>
        <b-dropdown-divider class="my-2"></b-dropdown-divider>
        <b-dropdown-item @click="logout()">
          <div class="d-flex">
            <span class="nav-drop-ico"
              ><img
                src="@/assets/img/icons/log-out.svg"
                width="18"
                class="align-middle"
                alt="Log out"
            /></span>
            <span>Sign Out</span>
          </div></b-dropdown-item
        >
        <b-dropdown-divider class="mt-2"></b-dropdown-divider>
      </ul>
    </b-popover>

    <div class="menu-open-close">
      <img src="@/assets/img/icons/menu-opener.png" class="open" width="25" />
      <img src="@/assets/img/icons/menu-closer.png" class="close" width="25" />
    </div>
  </nav>
</template>

<script>
import { getClientType } from "@/common/http.header";
import NavbarToggleButton from "@/components/NavbarToggleButton";
import MobMenu from "@/components/SidebarPlugin/MobMenu";
import { mapState } from "vuex";
import { destroyFullStory } from "@/common/fullstory";
import Gleap from "gleap";
import * as Sentry from "@sentry/browser";
import {
  removeHubspot,
  goToPage,
  getWelcomeDashCurrentClass,
  getStepDisable,
} from "@/common/functions";
const storeModules = [
  "payment",
  "campaign",
  "common",
  "autoresponder",
  "segment",
  "recipients",
  "report",
  "autoReport",
  "contact",
  "gallery",
  "user",
  "sender",
  "domain",
  "profile",
  "dashboard",
  "mctemplates",
];
export default {
  watch: {
    $route() {
      this.mobileMenu = false;
    },
  },
  created() {
    if (
      Object.keys(this.welcomeDashboardItems).length === 0 &&
      this.$ls.get("welcomeDashboardItems")
    ) {
      this.$store.commit("dashboard/setWelcomeDashboardItems", {
        items: JSON.parse(this.$ls.get("welcomeDashboardItems")),
      });
    }
    if (this.$route.name !== "Dashboard") {
      this.$store.dispatch("dashboard/getWelcomeDashboard");
    }
    this.$store.commit(
      "dashboard/setIsWelcomeDashboard",
      this.$ls.get("is_campaign_add")
    );
  },
  data() {
    return {
      showPopNoti: false,
      profilePic: "@/assets/img/theme/usr-pic.jpg",
      active: false,
      clientType: getClientType(),
      mobileMenu: false,
      userCardShow: false,
      loginData: JSON.parse(this.$ls.get("login_data")),
      allowTransaction: parseInt(this.$ls.get("allowTransaction")),
    };
  },
  computed: {
    ...mapState({
      userData: (state) => state.profile.userData,
      welcomeDashboardItems: (state) => state.dashboard.welcomeDashboardItems,
      isWelcomeDashboard: (state) => state.dashboard.isWelcomeDashboard,
    }),
    getProgress() {
      return (parseInt(this.stageCompleted) / 4) * 100;
    },
    getPending() {
      return 4 - parseInt(this.stageCompleted);
    },
    getCurrentClass() {
      return getWelcomeDashCurrentClass(this.welcomeDashboardItems);
    },
    stageCompleted() {
      var completed = 0;
      if (this.welcomeDashboardItems) {
        Object.entries(this.welcomeDashboardItems).forEach(([, value]) => {
          if (value === 2) {
            completed = completed + 1;
          }
        });
      }
      return completed;
    },
  },
  name: "sideBar",
  components: {
    NavbarToggleButton,
    MobMenu,
  },
  props: {
    autoClose: {
      type: Boolean,
      default: true,
      description:
        "Whether sidebar should autoclose on mobile when clicking an item",
    },
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  methods: {
    getStepDisableClass(module) {
      return getStepDisable(module, this.welcomeDashboardItems);
    },
    goTo(module) {
      goToPage(this, module, this.welcomeDashboardItems);
    },
    closeSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    showSidebar() {
      this.$sidebar.displaySidebar(true);
    },
    logout() {
      Sentry.configureScope((scope) => {
        scope.setUser(null);
      });
      var vm = this;
      storeModules.forEach(function (item) {
        vm.$store.dispatch(item + "/resetState");
      });
      destroyFullStory();
      this.$ls.remove("login_data");
      removeHubspot(vm);
      Gleap.clearIdentity();
      // this.$intercom.shutdown()
      this.$ls.remove("clientName");
      this.$ls.remove("expired_time");
      this.$router.push({
        name: "Login",
      });
    },
    getFirstLetter(val) {
      if (!val) {
        return "";
      }
      return val.charAt(0).toUpperCase();
    },
    onPopoverShow() {
      this.$refs.ReffpopoverProfile._toolpop
        .getTipElement()
        .classList.add("popover-profile-container");
      this.active = true;
      this.$emit("click");
    },
    onPopoverShow2() {
      this.$refs.refEmail._toolpop
        .getTipElement()
        .classList.add("platform-popover-container");
      this.active = true;
      this.$emit("click");
    },
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
